import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BlindsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"blinds"}/>
}
